import { writable, type Writable } from 'svelte/store'
import type { UrlParams } from '$types/urlParams'

export const urlParams: Writable<UrlParams | null> = writable(null)
